import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
var CELL_TYPE = 'text';
export default {
  editor: getEditor(CELL_TYPE),
  renderer: getRenderer(CELL_TYPE)
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/cellTypes/textType.js
// module id = 1938
// module chunks = 0